import { MultiFileDropZone } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZone';
import { Flex } from '@mantine/core';
import styled from 'styled-components';

export const StyledContainer = styled.div`
	width: 100%;
	background: white;
	border-left: ${({ theme }) => `1px solid ${theme.v2.color.neutral[300]}`};
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const PanelContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1rem;
	width: 100%;
`;

export const HistoryEventContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0;
`;

export const ConnectingLine = styled.div`
	width: 1px;
	background-color: ${({ theme }) => theme.v2.color.neutral[300]};
	flex-grow: 1;
`;

export const EventContent = styled.div`
	flex: 1;
	padding: 8px 0 8px 8px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	max-width: 90%;
`;

export const DocumentCard = styled.div`
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	border-radius: 4px;
	padding: 0.5rem;
	display: flex;
	align-items: center;
	gap: 0.25rem;
	place-self: flex-start;
`;

export const Dot = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.v2.color.neutral[300]};
	flex-shrink: 0;
`;

export const AdditionalDocumentContainer = styled(Flex).attrs(() => ({
	gap: '0.5rem',
	align: 'center',
	p: '0.5rem',
	w: '100%',
	justify: 'center',
}))`
	border-radius: 0.25rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	:hover {
		background-color: ${({ theme }) => theme.v3.colors.gray[0]};
		cursor: pointer;
	}
`;

interface StyledButtonProps {
	color?: string;
	$onHoverBackgroundColor?: string;
	$onHoverTextColor?: string;
	$onHoverIconColor?: string;
	$iconColor?: string;
	$loading?: boolean;
	disabled?: boolean;
}

export const StyledButtonContainer = styled.button<StyledButtonProps>`
	width: 100%;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	gap: 0.5rem;
	justify-content: center;
	border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	background-color: ${(props) => props.color || props.theme.v3.colors.gray[0]};
	opacity: ${(props) => (props.disabled || props.$loading ? 0.6 : 1)};
	cursor: ${(props) => (props.disabled || props.$loading ? 'not-allowed' : 'pointer')};

	svg {
		color: ${(props) => props.$iconColor || 'inherit'};
	}

	.un-hovered-state {
		display: block;
	}

	.hovered-state {
		display: none;
	}

	/* override styles in special cases using the status class name */
	&.REJECTED {
		opacity: 1;
	}

	&:hover {
		background-color: ${(props) =>
			props.disabled || props.$loading
				? props.color || props.theme.v3.colors.gray[0]
				: props.$onHoverBackgroundColor || props.theme.v3.colors.gray[1]};

		* {
			color: ${(props) =>
				props.disabled || props.$loading
					? 'inherit'
					: props.$onHoverTextColor || 'inherit'};
		}

		svg {
			color: ${(props) =>
				props.disabled || props.$loading
					? 'inherit'
					: props.$onHoverIconColor || 'inherit'};
		}

		.un-hovered-state {
			display: none;
		}

		.hovered-state {
			display: block;
		}
	}
`;

export const TabContainer = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	width: 100%;
`;

export const TabInnerContainer = styled.div`
	padding-left: 16px;
	padding-right: 16px;
	padding-top: 16px;
`;

export const StyledMultiFileDropZone = styled(MultiFileDropZone).attrs({
	icon: null,
	width: '100%',
	height: '100%',
	minWidth: '100%',
})`
	min-width: 100%;
	display: flex;
	align-items: center;
`;
